var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ScreenDialog,{ref:"wxShareDialog",staticClass:"c2c-wx-share-dialog",attrs:{"isAppendToBody":true}},[_c('img',{staticClass:"share-wx_img",attrs:{"src":_setup.guideWxImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }